import { date, showAlert } from '../../lib/helpers';
import { headers, search, dataResendEmailStatus, dataListEmailType} from './attributes';


export default {
  data: () => ({
    show: false,
    view: false,
    limit: '5',
    page: '1',
    options: {},
    dialogResend: false,
    headers,
    search,
    selectedRow: '',
    rdateFormatted: '',
    dateMenuRDate: false,
    itemsStatus: dataResendEmailStatus,
    listEmailType: dataListEmailType,
    dataResend: null,
  }),

  computed: {
    flashErrorMessage() {
      return this.$store.state.resendEmail.flashErrorMessage;
    },

    flashError: {
      get() {
        return this.$store.state.resendEmail.flashError;
      },
      set() {
        this.$store.commit('resendEmail/setFlashErrorMessage', '');
      },
    },

    errorValidation() {
      return this.$store.state.resendEmail.errors;
    },
    loading() {
      return this.$store.state.resendEmail.loading;
    },
    merchants() {
      return this.$store.state.resendEmail.allMerchants;
    },
    totalPage() {
      return this.$store.state.resendEmail.totalPage;
    },
    totalMerchants() {
      return this.$store.state.resendEmail.totalMerchants;
    },
  },

  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },

    'search.last_resend_at': {
      handler() {
        this.rdateFormatted = this.formatDate(this.search.last_resend_at);
        this.getData();
      },
    },
  },

  methods: {
    clearFilterData(field) {
      this.search[field] = ''; 
      this.getData(); 
    },
    selectRow(index) {
      if (this.selectedRow !== index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    clearSearch() {
      this.search.reference_number = '';
      this.search.mid = '';
      this.search.merchant_name = '';
      this.search.mpan = '';
      this.search.receiver = '';
      this.search.type = '';
      this.search.last_resend_at = '';
      this.search.resend_count = '';
      this.search.status = '';
      this.getData();
    },

    openDialogResend(data) {
      this.dialogResend = true;
      this.dataResend = data.id;
    },

    resend() {
      this.$store
        .dispatch('resendEmail/resendEmail', {
          id: this.dataResend,
        })
        .then((res) => {
          if (res) {
            this.getData();
            showAlert(
              this.$store,
              'Resend email success !',
              'mdi-check-circle',
              'green'
            );
          }
        })
        .finally(() => {
          this.dialogResend = false;
          this.dataResend = null;
        });
    },

    getData() {
      this.$store.commit('resendEmail/setFlashErrorMessage', '');
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store
        .dispatch('resendEmail/fetchDataLog', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage === 0) {
              this.options.page = 1;
            } else {
              this.options.page = this.totalPage;
            }
          }
        });
    },

    closeFlash() {
      this.$store.commit('resendEmail/setFlashErrorMessage', '');
    },

    formatDate(dateVal) {
      if (!dateVal) return null;

      const [year, month, day] = dateVal.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate(dateVal) {
      if (!dateVal) return null;

      const [day, month, year] = dateVal.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
  },
};